<template>
  <div class="page__single page__datenschutz">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>AGB</h1>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
name: "ABG"
}
</script>

<style scoped>

</style>